<template>
  <div class="animated fadeIn">
    <b-form @submit.prevent="onSubmit">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted text-uppercase">Sample Type Identification</span>
            </b-card-header>
            <div class="py-3 px-5">
              <b-form-group label="Name" :label-cols="2">
                <b-form-input
                  type="text"
                  v-model="form_data.name"
                  placeholder="Sample Type Name"
                />
              </b-form-group>
              <b-form-group label="Position" :label-cols="2">
                <b-form-input
                  type="number"
                  v-model.number="form_data.position"
                  placeholder="Sample Type Position"
                />
              </b-form-group>
              <b-form-group label="Description" :label-cols="2">
                <b-form-textarea
                  v-model="form_data.description"
                  placeholder="Sample Type Description"
                />
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button @click="submitForm" class="my-4 float-right py-3 px-5" variant="success">
            <i class="fal fa-save" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
  import SampleTypeCard from "@/components/lab/sampletype/SampleTypeCard";

  export default {
    name: "SampleTypeForm",
    components: {
      SampleTypeCard
    },
    props: {
      sample_type: {
        type: Object,
        default: () => null
      }
    },
    data() {
      return {
        form_data: {
          name: null,
          description: null,
          position: null
        }
      }
    },
    methods: {
      submitForm() {
        return this.$emit('submit', this.form_data);
      },
      initFormData() {
        const { description } = this.sample_type;
        
        this.form_data = {
          ...this.sample_type.cloneAttributes(true, true, ["id"]),
          description
        }
      }
    },
    created() {
      this.sample_type && this.initFormData();
    }
  }
</script>
